import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { ref, get, set, serverTimestamp } from "firebase/database";
import { auth, database } from "../firebase";
import "./Ballotpaper.css";

export default function Ballotpaper() {
  const [user, setUser] = useState(null);
  const [partiesData, setPartiesData] = useState([]);
  const [selectedParty, setSelectedParty] = useState(null);
  const [expandedParties, setExpandedParties] = useState(new Set());
  const [hasVoted, setHasVoted] = useState(false);
  const [loading, setLoading] = useState(true);

  /* 🔐 Auth listener */
  useEffect(() => {
    return onAuthStateChanged(auth, (u) => setUser(u));
  }, []);

  /* 📥 Load ballot */
  useEffect(() => {
  async function loadBallot() {
    const snap = await get(ref(database, "elections/pm26"));

    if (snap.exists()) {
      setPartiesData(snap.val());
    }

    setLoading(false);
  }

  loadBallot();
}, []);


  /* 🧾 Check vote log */
  useEffect(() => {
    if (!user) return;
    get(ref(database, `elections/pm26/logs/${user.uid}`)).then((snap) => {
      if (snap.exists()) setHasVoted(true);
    });
  }, [user]);

  const groupedParties = partiesData.reduce((acc, party) => {
    if (!acc[party.ballotNumber]) acc[party.ballotNumber] = [];
    acc[party.ballotNumber].push(party);
    return acc;
  }, {});

  const toggleExpand = (id) => {
    const s = new Set(expandedParties);
    s.has(id) ? s.delete(id) : s.add(id);
    setExpandedParties(s);
  };

  const castVote = async () => {
    if (!user || !selectedParty || hasVoted) return;

    await set(ref(database, `elections/pm26/logs/${user.uid}`), {
      uid: user.uid,
      partyId: selectedParty,
      timestamp: serverTimestamp(),
    });

    setHasVoted(true);
    alert("Vote successfully cast 🗳️");
  };

  if (loading) return <p>Loading ballot…</p>;

  if (!user)
    return <p style={{ color: "crimson" }}>You must be signed in to vote.</p>;

  if (hasVoted)
    return <p style={{ color: "green" }}>You have already voted.</p>;

  return (
    <div className="tbe-ballot-container">
      <main className="tbe-ballot-body">
        {Object.entries(groupedParties).map(([num, parties]) => (
          <div key={num} className="tbe-ballot-group">
            <div className="tbe-ballot-number-box">{num}</div>

            <div className="tbe-parties-column">
              {parties.map((party) => (
                <PartyRow
                  key={party.id}
                  party={party}
                  isSelected={selectedParty === party.id}
                  isExpanded={expandedParties.has(party.id)}
                  onVote={() => setSelectedParty(party.id)}
                  onToggleExpand={() => toggleExpand(party.id)}
                />
              ))}
            </div>
          </div>
        ))}
      </main>

      <footer className="tbe-ballot-footer">
        <button
          disabled={!selectedParty}
          className="tbe-cast-vote-btn"
          onClick={castVote}
        >
          Cast Vote
        </button>
      </footer>
    </div>
  );
}

function PartyRow({ party, isSelected, isExpanded, onVote, onToggleExpand }) {
  return (
    <div className="tbe-party-row-container">
      <button className="tbe-vote-button" onClick={onVote}>
        {isSelected && <div className="tbe-vote-oval-filled" />}
      </button>

      <div className="tbe-party-info">
        <h3>{party.nameEnglish}</h3>
        <p>{party.nameNative}</p>
        <span>{party.abbreviation}</span>

        <button onClick={onToggleExpand}>
          {isExpanded ? "Hide" : "View"} Candidate List (
          {party.candidates.length})
        </button>

        {isExpanded && (
          <ol>
            {party.candidates.map((c, i) => (
              <li key={c.id}>
                {i + 1}. <strong>{c.name}</strong>
                {c.position && <em> — {c.position}</em>}
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}
